import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { QuoteFlowModeEnum } from '@jove-frontend/enums';
import { trimText } from '@jove-frontend/utils';
import { cloneDeep, has, isArray, isNumber } from 'lodash';
import { getTruelyValueMap } from '../../constants/common';
import { EMPLOYERS_LIABILITY } from '../../constants/coverage';
import { greateAmericanCoverMap } from '../../constants/greateAmerican';
import { PROVIDER_SOURCE } from '../../constants/quote';
import { PolicyType, PriceFromEnum, YesNoEnum } from '../../shared/generated';
import { handleCoversSpeacialFieldInfo } from '../../utils/coverage';
import { getQuoteQuestionExtraRequestFieldData } from '../../utils/questions';
import { getQuoteCurrentInsuranceInfo } from '../../utils/quote';
import { convertTimeToServerStoredTimeDataWithZeroTime } from '../../utils/time';

var appendBasicInfo = function appendBasicInfo(data, quoteDetail) {
  appendPersonalInfo(data, quoteDetail);
  appendPromotionInfo(data, quoteDetail);
  appendHearAboutUsInfo(data, quoteDetail);
  appendFirstPaymentDelayedInceptionDate(data, quoteDetail);
  var flowMode = quoteDetail.flowMode,
      billingCycle = quoteDetail.billingCycle,
      specifyTotalPrice = quoteDetail.specifyTotalPrice,
      priceFrom = quoteDetail.priceFrom,
      policyNumber = quoteDetail.policyNumber,
      policyType = quoteDetail.policyType; // Fast tracker

  data.flowMode = flowMode; // Payment mode

  data.billingCycle = billingCycle; // Manual set price

  data.specifyTotalPrice = !!specifyTotalPrice ? Number(specifyTotalPrice) : null; // Pay plan: Temp boolean

  data.priceFrom = !!priceFrom ? PriceFromEnum.MANUAL : PriceFromEnum.API; // Policy number

  data.policyNumber = policyNumber; // Policy type

  data.policyType = policyType;
};

var appendPersonalInfo = function appendPersonalInfo(data, quoteDetail) {
  var firstName = quoteDetail.firstName,
      lastName = quoteDetail.lastName,
      email = quoteDetail.email,
      phone = quoteDetail.phone,
      country = quoteDetail.country;
  data.firstName = firstName;
  data.lastName = lastName;
  data.email = email;
  data.phone = phone;
  data.country = country;
};

var appendHearAboutUsInfo = function appendHearAboutUsInfo(data, quoteDetail) {
  var hearAboutSource = quoteDetail.hearAboutSource,
      hearAboutCustomInput = quoteDetail.hearAboutCustomInput;
  data.hearAboutSource = hearAboutSource;
  data.hearAboutCustomInput = hearAboutCustomInput;
};

var appendFirstPaymentDelayedInceptionDate = function appendFirstPaymentDelayedInceptionDate(data, quoteDetail) {
  var firstPaymentDelayedInceptionDate = quoteDetail.firstPaymentDelayedInceptionDate;
  data.firstPaymentDelayedInceptionDate = firstPaymentDelayedInceptionDate;
};

var appendBusinessType = function appendBusinessType(data, quoteDetail) {
  var businessType = quoteDetail.businessType;
  data.businessType = businessType;
};

var appendCompanyAndAddress = function appendCompanyAndAddress(data, quoteDetail) {
  var companyName = quoteDetail.companyName,
      businessAddress = quoteDetail.businessAddress,
      streetNumber = quoteDetail.streetNumber,
      businessPostcode = quoteDetail.businessPostcode,
      businessCity = quoteDetail.businessCity,
      businessCounty = quoteDetail.businessCounty,
      businessState = quoteDetail.businessState,
      detailedAddress = quoteDetail.detailedAddress,
      companyIncorporationDate = quoteDetail.companyIncorporationDate,
      registrationNumber = quoteDetail.registrationNumber,
      businessCountry = quoteDetail.businessCountry,
      taxNumber = quoteDetail.taxNumber;
  data.businessCountry = businessCountry;
  data.companyName = trimText(companyName);
  data.businessAddress = trimText(businessAddress);
  data.streetNumber = trimText(streetNumber);
  data.businessPostcode = trimText(businessPostcode);
  data.businessCity = trimText(businessCity);
  data.businessCounty = trimText(businessCounty);
  data.businessState = trimText(businessState);
  data.businessAddress2 = trimText(detailedAddress);
  data.detailedAddress = trimText(detailedAddress);
  data.companyIncorporationDate = !!companyIncorporationDate ? convertTimeToServerStoredTimeDataWithZeroTime(companyIncorporationDate) : null;

  if ([PROVIDER_SOURCE().GREATEAMERICAN.value, PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(quoteDetail.providerCode)) {} else {
    data.registrationNumber = trimText(registrationNumber);
    data.taxNumber = trimText(taxNumber);
  }
};

var appendPolicyPeriodDate = function appendPolicyPeriodDate(data, quoteDetail) {
  var projectPeriodStart = quoteDetail.projectPeriodStart,
      updateEffectiveDate = quoteDetail.updateEffectiveDate,
      customUpdateEffectiveDate = quoteDetail.customUpdateEffectiveDate;
  data.projectPeriodStart = projectPeriodStart ? convertTimeToServerStoredTimeDataWithZeroTime(projectPeriodStart) : null;
  data.updateEffectiveDate = customUpdateEffectiveDate ? customUpdateEffectiveDate : updateEffectiveDate ? convertTimeToServerStoredTimeDataWithZeroTime(updateEffectiveDate) : null;
};

var appendDotNumber = function appendDotNumber(data, quoteDetail) {
  var dotNumber = quoteDetail.dotNumber,
      haveDotNumber = quoteDetail.haveDotNumber;
  data.dotNumber = dotNumber;
  data.haveNoDotNumber = !haveDotNumber;
};

var appendDeclarations = function appendDeclarations(data, quoteDetail) {
  var declarationQuestions = quoteDetail.declarationQuestions,
      declarationComment = quoteDetail.declarationComment;
  data.declarationQuestions = declarationQuestions;
  data.declarationComment = declarationComment;
};

var appendNumberOfDrivers = function appendNumberOfDrivers(data, quoteDetail) {
  var numberOfDrivers = quoteDetail.numberOfDrivers;
  data.numberOfDrivers = Number(numberOfDrivers || 1);
};

var appendVehicles = function appendVehicles(data, quoteDetail) {
  var vehicleList = quoteDetail.vehicleList;
  data.vehicleList = vehicleList;
};

var appendCovers = function appendCovers(data, quoteDetail) {
  var covers = quoteDetail.covers,
      providerCode = quoteDetail.providerCode,
      turnOnCombinedPackage = quoteDetail.turnOnCombinedPackage,
      country = quoteDetail.country,
      coverageConfiguration = quoteDetail.coverageConfiguration;
  var newCovers = {};

  if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode)) {
    newCovers = _objectSpread(_objectSpread({}, covers), {}, _defineProperty({}, greateAmericanCoverMap.subhaulerOwnerPperator.value, true));
  } else {
    newCovers = covers || {};
  }

  handleCoversSpeacialFieldInfo(newCovers, {
    providerCode: providerCode,
    country: country,
    coverageConfiguration: coverageConfiguration
  });
  data.covers = newCovers;
  data.turnOnCombinedPackage = !!turnOnCombinedPackage;
};

var appendBusinessActivity = function appendBusinessActivity(data, quoteDetail) {
  var businessActivity = quoteDetail.businessActivity,
      customizedBusinessActivity = quoteDetail.customizedBusinessActivity,
      r2ROption = quoteDetail.r2ROption,
      propertyActivities = quoteDetail.propertyActivities,
      customizedActivityDescription = quoteDetail.customizedActivityDescription;
  data.businessActivity = !!customizedBusinessActivity ? null : businessActivity || null;
  data.customizedBusinessActivity = customizedBusinessActivity;
  data.r2ROption = r2ROption;
  data.propertyActivities = propertyActivities;
  data.customizedActivityDescription = customizedActivityDescription;
};

var appendPolicyOfType = function appendPolicyOfType(data, quoteDetail) {
  var policyType = quoteDetail.policyType;
  data.policyType = policyType;
};

var appendEstimatedTurnover = function appendEstimatedTurnover(data, quoteDetail) {
  var turnover = quoteDetail.turnover,
      turnoverRaw = quoteDetail.turnoverRaw,
      providerCode = quoteDetail.providerCode;

  if (![PROVIDER_SOURCE().ACCELERANT_GIT.value, PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode)) {
    data.turnover = null;
    data.turnoverRaw = turnoverRaw;
  } else {
    data.turnover = turnover;
    data.turnoverRaw = null;
  }
};

var appendIncomeSplit = function appendIncomeSplit(data, quoteDetail) {
  var incomeOrigin = quoteDetail.incomeOrigin,
      extendedGeographicCoverage = quoteDetail.extendedGeographicCoverage;
  var newIncomeOrigin = cloneDeep(incomeOrigin || {});

  for (var _i = 0, _Object$keys = Object.keys(newIncomeOrigin); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    newIncomeOrigin[key] = Number(newIncomeOrigin[key] || 0);
  }

  data.incomeOrigin = newIncomeOrigin;
  data.extendedGeographicCoverage = !!newIncomeOrigin['USA'];
};

var appendCoverType = function appendCoverType(data, quoteDetail) {
  var coverType = quoteDetail.coverType;
  data.coverType = coverType;
};

var appendEmployeesComposition = function appendEmployeesComposition(data, quoteDetail) {
  var elSize = quoteDetail.elSize; // The BE requires special handle

  var newElSize = {};

  if (isNumber(elSize === null || elSize === void 0 ? void 0 : elSize.manualEmployees)) {
    newElSize.manualEmployees = elSize.manualEmployees;
  }

  if (isNumber(elSize === null || elSize === void 0 ? void 0 : elSize.clericalEmployees)) {
    newElSize.clericalEmployees = elSize.clericalEmployees;
  }

  if (Object.keys(newElSize).length > 0) {
    data.elSize = newElSize;
  } else {
    data.elSize = null;
  }
};

var appendEmployees = function appendEmployees(data, quoteDetail) {
  var employees = quoteDetail.employees,
      limitedEmployeeCount = quoteDetail.limitedEmployeeCount;
  data.employees = employees;
  data.limitedEmployeeCount = limitedEmployeeCount;
};

var appendErn = function appendErn(data, quoteDetail) {
  var ern = quoteDetail.ern,
      ernExempt = quoteDetail.ernExempt;
  data.ern = ern;
  data.ernStatus = !ern && !ernExempt ? 'pending' : !!ernExempt ? 'exempt' : 'informed';
};

var appendRetroactiveDate = function appendRetroactiveDate(data, quoteDetail) {
  var retroactiveDate = quoteDetail.retroactiveDate;
  data.retroactiveDate = !!retroactiveDate ? convertTimeToServerStoredTimeDataWithZeroTime(retroactiveDate) : null;
};

var appendPausingInsurance = function appendPausingInsurance(data, quoteDetail) {
  var pausingInsurance = quoteDetail.pausingInsurance;
  data.pausingInsurance = pausingInsurance;
};

var appendClientName = function appendClientName(data, quoteDetail) {
  var clientName = quoteDetail.clientName;
  data.clientName = clientName;
};

var appendContractPeriod = function appendContractPeriod(data, quoteDetail) {
  var contractAddMonths = quoteDetail.contractAddMonths,
      projectPeriodStart = quoteDetail.projectPeriodStart,
      projectPeriodEnd = quoteDetail.projectPeriodEnd;
  data.contractAddMonths = contractAddMonths;
  data.projectPeriodStart = !!projectPeriodStart ? convertTimeToServerStoredTimeDataWithZeroTime(projectPeriodStart) : null;
  data.projectPeriodEnd = !!projectPeriodEnd ? convertTimeToServerStoredTimeDataWithZeroTime(projectPeriodEnd) : null;
};

var appendRateAndTotalEstimatedIncome = function appendRateAndTotalEstimatedIncome(data, quoteDetail) {
  var _rateAndTotal$income;

  var rateAndTotal = quoteDetail.rateAndTotal;
  data.rateAndTotal = rateAndTotal;
  data.income = (_rateAndTotal$income = rateAndTotal === null || rateAndTotal === void 0 ? void 0 : rateAndTotal.income) !== null && _rateAndTotal$income !== void 0 ? _rateAndTotal$income : null;
};

var appendPromotionInfo = function appendPromotionInfo(data, quoteDetail) {
  var promotion = quoteDetail.promotion,
      promotionId = quoteDetail.promotionId,
      manualDiscount = quoteDetail.manualDiscount;
  data.promotion = promotion;
  data.promotionId = promotionId;
  data.manualDiscount = manualDiscount;
};

var appendClaims = function appendClaims(data, quoteDetail) {
  var hasClaims = quoteDetail.hasClaims,
      claimList = quoteDetail.claimList;
  data.hasClaims = hasClaims;
  data.claimList = (claimList || []).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      date: item.date ? convertTimeToServerStoredTimeDataWithZeroTime(item.date) : null
    });
  });
};

var appendYearsInBusiness = function appendYearsInBusiness(data, quoteDetail) {
  var yearsInBusiness = quoteDetail.yearsInBusiness;
  data.yearsInBusiness = yearsInBusiness;
};

var appendRecruitmentSpecialInfo = function appendRecruitmentSpecialInfo(data, quoteDetail) {
  var recruitmentBusinessType = quoteDetail.recruitmentBusinessType,
      recruitmentSplitPercent = quoteDetail.recruitmentSplitPercent,
      payrollSplitPercent = quoteDetail.payrollSplitPercent,
      payrollForPlacedCandidate = quoteDetail.payrollForPlacedCandidate,
      permanentSplitPercentForPlacedCandidate = quoteDetail.permanentSplitPercentForPlacedCandidate,
      temporarySplitPercentForPlacedCandidate = quoteDetail.temporarySplitPercentForPlacedCandidate,
      placementTypeAndSplitList = quoteDetail.placementTypeAndSplitList;
  data.recruitmentBusinessType = recruitmentBusinessType;
  data.recruitmentSplitPercent = recruitmentSplitPercent;
  data.payrollSplitPercent = payrollSplitPercent;
  data.payrollForPlacedCandidate = payrollForPlacedCandidate;
  data.permanentSplitPercentForPlacedCandidate = permanentSplitPercentForPlacedCandidate;
  data.temporarySplitPercentForPlacedCandidate = temporarySplitPercentForPlacedCandidate;
  data.placementTypeAndSplitList = (placementTypeAndSplitList || []).map(function (item) {
    return {
      placement_type: item.value,
      value: Number(item.percent || 0),
      label: item.label
    };
  });
};

var appendHiscoxUSSpecialInfo = function appendHiscoxUSSpecialInfo(data, quoteDetail) {
  var _declarationQuestions2;

  var declarationQuestions = quoteDetail.declarationQuestions,
      squareFeetOccupiedByYou = quoteDetail.squareFeetOccupiedByYou,
      estSalesLargestProject = quoteDetail.estSalesLargestProject,
      estSalesLargestCustmr1 = quoteDetail.estSalesLargestCustmr1,
      estmtdPayrollExpense = quoteDetail.estmtdPayrollExpense,
      numOfOwners = quoteDetail.numOfOwners,
      professionalLicenseAttestation = quoteDetail.professionalLicenseAttestation,
      similarInsurance = quoteDetail.similarInsurance,
      extraDeclarationSelectOptionList = quoteDetail.extraDeclarationSelectOptionList;
  var questionExtraMap = getQuoteQuestionExtraRequestFieldData();
  Object.keys(questionExtraMap).forEach(function (key) {
    if (has(declarationQuestions, key)) {
      var _declarationQuestions;

      data[questionExtraMap[key]] = (_declarationQuestions = declarationQuestions[key]) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue;
    }
  });
  data.estSalesLargestProject = estSalesLargestProject;
  data.estSalesLargestCustmr1 = estSalesLargestCustmr1;
  data.squareFeetOccupiedByYou = squareFeetOccupiedByYou;
  data.estmtdPayrollExpense = estmtdPayrollExpense;
  data.itConsultingOrTechnologyServices = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions2 = declarationQuestions['hiscox_it_consulting_or_technology_services']) === null || _declarationQuestions2 === void 0 ? void 0 : _declarationQuestions2.truelyValue;
  data.itConsultingTechnologyServicesOptionList = data.itConsultingOrTechnologyServices === false ? extraDeclarationSelectOptionList : [];
  data.professionalLicenseAttestation = professionalLicenseAttestation;
  data.numOfOwners = numOfOwners;
  data.similarInsurance = similarInsurance;
  ['haveProfLiabilityInsurance', 'professionalLiabilityRetroactiveDateAvailable', 'haveCyberInsurance', 'cyberRetroactiveDateAvailable', 'mediaLiabilityRetroactiveDateAvailable'].forEach(function (key) {
    data[key] = !!quoteDetail[key] ? quoteDetail[key] === getTruelyValueMap().yes.value : null;
  });
  ['professionalLiabilityRetroactiveDate', 'cyberRetroactiveDate', 'mediaLiabilityRetroactiveDate'].forEach(function (key) {
    data[key] = !!quoteDetail[key] ? convertTimeToServerStoredTimeDataWithZeroTime(quoteDetail[key]) : null;
  });
};

export var appendAccountancyActivities = function appendAccountancyActivities(data, quoteDetail) {
  var accountancyActivityList = quoteDetail.accountancyActivityList,
      accountancyOtherActivity = quoteDetail.accountancyOtherActivity;
  data.activitySplit = {};
  accountancyActivityList.forEach(function (item) {
    data.activitySplit[item.value] = Number(item.count || 0);
  });
  data.otherAccountancyActivityDesc = accountancyOtherActivity;
};
export var appendAccountancyProfessionalAssociationsMember = function appendAccountancyProfessionalAssociationsMember(data, quoteDetail) {
  var professionalAssociationsMember = quoteDetail.professionalAssociationsMember;
  data.membership = professionalAssociationsMember || null;
};

var appendCoverageConfiguration = function appendCoverageConfiguration(data, quoteDetail) {
  var coverageConfiguration = quoteDetail.coverageConfiguration;
  data.coverageConfiguration = coverageConfiguration || null;
};

var appendCoveragePropertyInfo = function appendCoveragePropertyInfo(data, quoteDetail) {
  var propertyList = quoteDetail.propertyList,
      portableEquipmentInsured = quoteDetail.portableEquipmentInsured,
      businessInterruptionInsured = quoteDetail.businessInterruptionInsured,
      noNeedBusinessInterruptionCover = quoteDetail.noNeedBusinessInterruptionCover;
  data.propertyList = propertyList || [];
  data.portableEquipmentInsured = portableEquipmentInsured;
  data.businessInterruptionInsured = businessInterruptionInsured;
  data.noNeedBusinessInterruptionCover = noNeedBusinessInterruptionCover;
};

var appendCustomInputCoverages = function appendCustomInputCoverages(data, quoteDetail) {
  var customizedCovers = quoteDetail.customizedCovers;
  var map = {};
  (isArray(customizedCovers) ? customizedCovers : []).forEach(function (item) {
    var _item$name;

    var key = ((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.trim()) || '';

    if (key) {
      map[key] = item.coverage;
    }
  });
  data.customizedCovers = map;
};

var appendBerAssessor = function appendBerAssessor(data, quoteDetail) {
  var assessorRegistrationNumber = quoteDetail.assessorRegistrationNumber,
      berTypes = quoteDetail.berTypes;
  data.assessorRegistrationNumber = assessorRegistrationNumber || '';
  data.berTypes = berTypes || [];
};

var convertChubbLocalQuoteDataToServerStructureData = function convertChubbLocalQuoteDataToServerStructureData(data, quoteDetail) {
  var technologyIndustry = quoteDetail.technologyIndustry,
      undertakenWork = quoteDetail.undertakenWork,
      involvedActivities = quoteDetail.involvedActivities,
      contract1M = quoteDetail.contract1M,
      policyType = quoteDetail.policyType,
      businessActivity = quoteDetail.businessActivity,
      covers = quoteDetail.covers;
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // * QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_BusinessActivities

  appendBusinessActivity(data, quoteDetail);

  if (businessActivity !== 'IT-020') {
    // QuoteProcess_ChubbTechIndustry
    data.technologyIndustry = technologyIndustry;
  } // QuoteProcess_AdditionalActivities


  data.undertakenWork = undertakenWork;
  data.involvedActivities = !!undertakenWork ? involvedActivities || [] : []; // QuoteProcess_TypeOfPolicy

  appendPolicyOfType(data, quoteDetail);

  if (policyType === PolicyType.ANNUAL_FLEXIBLE) {
    // QuoteProcess_ChubbContractDetails
    data.contract1M = contract1M; // QuoteProcess_EstimatedTurnover

    appendEstimatedTurnover(data, quoteDetail); // QuoteProcess_EmployerReferenceNumber

    appendErn(data, quoteDetail); // QuoteProcess_RetroactiveDate

    appendRetroactiveDate(data, quoteDetail); // QuoteProcess_PausingInsurance

    appendPausingInsurance(data, quoteDetail);
  } else if (policyType === PolicyType.CONTRACT_SPECIFIC) {
    // QuoteProcess_ClientName
    appendClientName(data, quoteDetail); // QuoteProcess_ContractPeriod

    appendContractPeriod(data, quoteDetail); // QuoteProcess_RateAndTotalEstimatedIncome

    appendRateAndTotalEstimatedIncome(data, quoteDetail);
  }

  if (!!(covers !== null && covers !== void 0 && covers[EMPLOYERS_LIABILITY])) {
    // QuoteProcess_EmployeesComposition
    appendEmployeesComposition(data, quoteDetail);
  } // QuoteProcess_IncomeSplit


  appendIncomeSplit(data, quoteDetail); // QuoteProcess_CustomizeCover

  appendCovers(data, quoteDetail); // QuoteProcess_Declarations

  appendDeclarations(data, quoteDetail);
  return data;
};

var convertGreatAmericanLocalQuoteDataToServerStructureData = function convertGreatAmericanLocalQuoteDataToServerStructureData(data, quoteDetail) {
  var typeOfOperation = quoteDetail.typeOfOperation,
      commodityList = quoteDetail.commodityList,
      averageRadiusOfOperation = quoteDetail.averageRadiusOfOperation,
      numberLossesLast3Years = quoteDetail.numberLossesLast3Years,
      totalLossesPaidLast3Years = quoteDetail.totalLossesPaidLast3Years,
      noAnyCargoLoss = quoteDetail.noAnyCargoLoss,
      minorViolations = quoteDetail.minorViolations,
      dotNumberPriorAuthority = quoteDetail.dotNumberPriorAuthority,
      declarationQuestions = quoteDetail.declarationQuestions,
      flowMode = quoteDetail.flowMode,
      typeOfCommodities = quoteDetail.typeOfCommodities,
      acceptanceCriteriaSelectCheckedList = quoteDetail.acceptanceCriteriaSelectCheckedList;
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_DotAsk + QuoteProcess_DotNumber

  appendDotNumber(data, quoteDetail); // QuoteProcess_GreateAmericanFastProcessCriteria

  if (has(declarationQuestions, 'great_american_fast_process_criteria')) {
    var _declarationQuestions3;

    data.isSimpleFlow = !!((_declarationQuestions3 = declarationQuestions.great_american_fast_process_criteria) !== null && _declarationQuestions3 !== void 0 && _declarationQuestions3.truelyValue);
  } // QuoteProcess_TypeOfRemovalJob


  data.typeOfOperation = typeOfOperation; // QuoteProcess_GreateAmericanEnterCustomerHouse: enter_customer_house, enter_customer_house_carry_heavy_items
  // QuoteProcess_ExperienceCarryMixedGoods: greate_american_experience_carry_mixed_goods
  // QuoteProcess_UseWhatCar: greate_american_use_what_car

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_use_what_car) {
    var _declarationQuestions4;

    data.isDryVan = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions4 = declarationQuestions.greate_american_use_what_car) === null || _declarationQuestions4 === void 0 ? void 0 : _declarationQuestions4.yesOrNoLowerCaseLabel;
  } // QuoteProcess_MixedCourierWork: greate_american_mixed_courier_work


  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_mixed_courier_work) {
    var _declarationQuestions5;

    data.isMainlyRetailGiant = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions5 = declarationQuestions.greate_american_mixed_courier_work) === null || _declarationQuestions5 === void 0 ? void 0 : _declarationQuestions5.yesOrNoLowerCaseLabel;
  } // QuoteProcess_TypeOfCommodities + QuoteProcess_PercentageHauledCommodity


  data.typeOfCommodities = typeOfCommodities;
  data.commodityList = (commodityList || []).map(function (item) {
    return {
      option_id: item.value,
      value: Number(item.count || 0)
    };
  }); // QuoteProcess_AverageRadiusOperation

  data.averageRadiusOfOperation = averageRadiusOfOperation; // QuoteProcess_Subhauler: greate_american_subhauler, greate_american_subhauler_indemnify

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_subhauler) {
    var _declarationQuestions6;

    data.applicantTransportCargoToMotorCarrier = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions6 = declarationQuestions.greate_american_subhauler) === null || _declarationQuestions6 === void 0 ? void 0 : _declarationQuestions6.yesOrNoLowerCaseLabel;
  }

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_subhauler_indemnify) {
    var _declarationQuestions7;

    data.applicantTransportCargoToMotorCarrierReimburse = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions7 = declarationQuestions.greate_american_subhauler_indemnify) === null || _declarationQuestions7 === void 0 ? void 0 : _declarationQuestions7.yesOrNoLowerCaseLabel;
  } // QuoteProcess_CargoLoses: greate_american_cargo_loses


  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_cargo_loses) {
    var _declarationQuestions8;

    data.cargoLossesLast3Years = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions8 = declarationQuestions.greate_american_cargo_loses) === null || _declarationQuestions8 === void 0 ? void 0 : _declarationQuestions8.yesOrNoLowerCaseLabel;
  } // QuoteProcess_NumberOfLosses


  data.numberLossesLast3Years = !!numberLossesLast3Years || numberLossesLast3Years === 0 ? Number(numberLossesLast3Years) : null;
  data.totalLossesPaidLast3Years = !!totalLossesPaidLast3Years || totalLossesPaidLast3Years === 0 ? Number(totalLossesPaidLast3Years) : null;
  data.noAnyCargoLoss = noAnyCargoLoss; // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_YearsOfExperience

  appendYearsInBusiness(data, quoteDetail); // QuoteProcess_NumberOfDrivers

  appendNumberOfDrivers(data, quoteDetail); // QuoteProcess_DriverAgeRange: greate_american_drivers_age_range, greate_american_drivers_age_range_acceptable_dot

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_drivers_age_range) {
    var _declarationQuestions9;

    data.ageOfDriver = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions9 = declarationQuestions.greate_american_drivers_age_range) === null || _declarationQuestions9 === void 0 ? void 0 : _declarationQuestions9.yesOrNoLowerCaseLabel;
  }

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_drivers_age_range_acceptable_dot) {
    var _declarationQuestions10;

    data.driverAgeRangeAcceptableDot = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions10 = declarationQuestions.greate_american_drivers_age_range_acceptable_dot) === null || _declarationQuestions10 === void 0 ? void 0 : _declarationQuestions10.yesOrNoLowerCaseLabel;
  } // QuoteProcess_NumberOfMinorViolation


  data.minorViolations = !!minorViolations || minorViolations === 0 ? Number(minorViolations) : null; // QuoteProcess_US_Vehicles

  appendVehicles(data, quoteDetail); // QuoteProcess_AcceptanceCriteria: greate_american_acceptance_criteria, greate_american_acceptance_criteria_different_name

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_acceptance_criteria) {
    var _declarationQuestions11, _declarationQuestions12;

    data.acceptanceCriteriaInsurance = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions11 = declarationQuestions.greate_american_acceptance_criteria) === null || _declarationQuestions11 === void 0 ? void 0 : _declarationQuestions11.truelyValue;
    var acceptanceCriteriaTruely = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions12 = declarationQuestions.greate_american_acceptance_criteria) === null || _declarationQuestions12 === void 0 ? void 0 : _declarationQuestions12.truelyValue;

    if (acceptanceCriteriaTruely) {
      data.coverageCancelledOrNonRenewedInLast5Years = data.currentCarrier = YesNoEnum.YES;
    } else {
      data.coverageCancelledOrNonRenewedInLast5Years = acceptanceCriteriaSelectCheckedList !== null && acceptanceCriteriaSelectCheckedList !== void 0 && acceptanceCriteriaSelectCheckedList.includes('coverage_cancelled_or_non_renewed_in_last_5_years') ? YesNoEnum.NO : YesNoEnum.YES;
      data.currentCarrier = acceptanceCriteriaSelectCheckedList !== null && acceptanceCriteriaSelectCheckedList !== void 0 && acceptanceCriteriaSelectCheckedList.includes('current_carrier') ? YesNoEnum.NO : YesNoEnum.YES;
    }
  }

  data.dotNumberPriorAuthority = dotNumberPriorAuthority;

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_acceptance_criteria_different_name) {
    var _declarationQuestions13;

    data.applicantAuthorityInLast5Years = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions13 = declarationQuestions.greate_american_acceptance_criteria_different_name) === null || _declarationQuestions13 === void 0 ? void 0 : _declarationQuestions13.yesOrNoLowerCaseLabel;
  } // QuoteProcess_UserConfirmReceived:
  // QuoteProcess_MotorTruckCargoCover + QuoteProcess_WhatIncludedMtcInsurance + QuoteProcess_MtcOptionalCoverage / QuoteProcess_GreateAmericanFastProcessCovers


  appendCovers(data, quoteDetail); // QuoteProcess_RefrigeratedEquipment: greate_american_refrigerated_equipment

  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_refrigerated_equipment) {
    var _declarationQuestions14;

    data.refrigerationEquipment = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions14 = declarationQuestions.greate_american_refrigerated_equipment) === null || _declarationQuestions14 === void 0 ? void 0 : _declarationQuestions14.yesOrNoLowerCaseLabel;
  } // QuoteProcess_RefrigirationYearExperience: greate_american_refrigiration_year_experience


  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_refrigiration_year_experience) {
    var _declarationQuestions15;

    data.refrigeratedCommodities = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions15 = declarationQuestions.greate_american_refrigiration_year_experience) === null || _declarationQuestions15 === void 0 ? void 0 : _declarationQuestions15.yesOrNoLowerCaseLabel;
  } // QuoteProcess_RiggingTransportingGoods: greate_american_rigging_transporting_goods


  if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_rigging_transporting_goods) {
    var _declarationQuestions16;

    data.riggingInvolved = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions16 = declarationQuestions.greate_american_rigging_transporting_goods) === null || _declarationQuestions16 === void 0 ? void 0 : _declarationQuestions16.yesOrNoLowerCaseLabel;
  } // Declarations


  appendDeclarations(data, quoteDetail); // Special handler

  if (flowMode === QuoteFlowModeEnum.fastTrack) {
    if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.great_american_fast_process_declaration) {
      var _declarationQuestions17;

      data.declarationsSet = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions17 = declarationQuestions.great_american_fast_process_declaration) === null || _declarationQuestions17 === void 0 ? void 0 : _declarationQuestions17.yesOrNoLowerCaseLabel;
    }
  } else {
    if (declarationQuestions !== null && declarationQuestions !== void 0 && declarationQuestions.greate_american_declaration_p1) {
      var _declarationQuestions18;

      data.declarationsSet = declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions18 = declarationQuestions.greate_american_declaration_p1) === null || _declarationQuestions18 === void 0 ? void 0 : _declarationQuestions18.yesOrNoLowerCaseLabel;
    }
  }

  return data;
};

var convertGreatAmericanBusinessInsuranceLocalQuoteDataToServerStructureData = function convertGreatAmericanBusinessInsuranceLocalQuoteDataToServerStructureData(data, quoteDetail) {
  var _declarationQuestions20;

  var declarationQuestions = quoteDetail.declarationQuestions,
      workRequireCertifiedPercentage = quoteDetail.workRequireCertifiedPercentage,
      writtenContractPercentage = quoteDetail.writtenContractPercentage,
      subcontractorPercentage = quoteDetail.subcontractorPercentage,
      totalCostClaims = quoteDetail.totalCostClaims,
      totalInsurancePremiumPaid = quoteDetail.totalInsurancePremiumPaid,
      staffExperienceYears = quoteDetail.staffExperienceYears,
      claimAdjustersEstimateClaimsNumber = quoteDetail.claimAdjustersEstimateClaimsNumber,
      claimAdjustersEstimateClaimsAverageValue = quoteDetail.claimAdjustersEstimateClaimsAverageValue,
      extraDeclarationSelectOptionList = quoteDetail.extraDeclarationSelectOptionList,
      extraDeclarationComment = quoteDetail.extraDeclarationComment;
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail);

  if (has(declarationQuestions, 'greate_american_us_quick_journey_criteria')) {
    var _declarationQuestions19;

    data.isSimpleFlow = !!((_declarationQuestions19 = declarationQuestions.greate_american_us_quick_journey_criteria) !== null && _declarationQuestions19 !== void 0 && _declarationQuestions19.truelyValue);
  } // yearsInBusiness


  appendYearsInBusiness(data, quoteDetail);
  appendBusinessActivity(data, quoteDetail);
  appendEstimatedTurnover(data, quoteDetail);
  appendCovers(data, quoteDetail);
  appendRetroactiveDate(data, quoteDetail); // Declarations

  appendDeclarations(data, quoteDetail);
  var chooseFalse = (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions20 = declarationQuestions['greate_american_us_class_service_declarations']) === null || _declarationQuestions20 === void 0 ? void 0 : _declarationQuestions20.truelyValue) === false;
  return _objectSpread(_objectSpread({}, data), {}, {
    workRequireCertifiedPercentage: workRequireCertifiedPercentage,
    writtenContractPercentage: writtenContractPercentage,
    subcontractorPercentage: subcontractorPercentage,
    totalCostClaims: totalCostClaims,
    totalInsurancePremiumPaid: totalInsurancePremiumPaid,
    staffExperienceYears: staffExperienceYears,
    claimAdjustersEstimateClaimsNumber: claimAdjustersEstimateClaimsNumber,
    claimAdjustersEstimateClaimsAverageValue: claimAdjustersEstimateClaimsAverageValue,
    extraDeclarationSelectOptionList: chooseFalse ? extraDeclarationSelectOptionList || [] : [],
    extraDeclarationComment: chooseFalse && extraDeclarationSelectOptionList !== null && extraDeclarationSelectOptionList !== void 0 && extraDeclarationSelectOptionList.includes('Other') ? extraDeclarationComment : ''
  });
};

var convertAccelerantLocalQuoteDataToServerStructureData = function convertAccelerantLocalQuoteDataToServerStructureData(data, quoteDetail) {
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // * QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_BusinessActivities

  appendBusinessActivity(data, quoteDetail); // QuoteProcess_EstimatedTurnover

  appendEstimatedTurnover(data, quoteDetail); // QuoteProcess_IncomeSplit

  appendIncomeSplit(data, quoteDetail); // QuoteProcess_CoverType

  appendCoverType(data, quoteDetail); // QuoteProcess_CustomizeCover

  appendCovers(data, quoteDetail); // QuoteProcess_EmployeesComposition

  appendEmployeesComposition(data, quoteDetail); // QuoteProcess_Declarations

  appendDeclarations(data, quoteDetail); // QuoteProcess_RetroactiveDate

  appendRetroactiveDate(data, quoteDetail); // QuoteProcess_Claims

  appendClaims(data, quoteDetail); // Accountancy activities

  appendAccountancyActivities(data, quoteDetail); // Accountancy professional associations member

  appendAccountancyProfessionalAssociationsMember(data, quoteDetail); // Property

  appendCoveragePropertyInfo(data, quoteDetail); // Custom input coverage

  appendCustomInputCoverages(data, quoteDetail); // BER Assessor

  appendBerAssessor(data, quoteDetail);
  return data;
};

var convertRecruitmentLocalQuoteDataToServerStructureData = function convertRecruitmentLocalQuoteDataToServerStructureData(data, quoteDetail) {
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // * QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_RetroactiveDate

  appendRetroactiveDate(data, quoteDetail); // QuoteProcess_EstimatedTurnover

  appendEstimatedTurnover(data, quoteDetail); // QuoteProcess_IncomeSplit

  appendIncomeSplit(data, quoteDetail); // QuoteProcess_Employees

  appendEmployees(data, quoteDetail); // QuoteProcess_EmployerReferenceNumber

  appendErn(data, quoteDetail); // QuoteProcess_CoverType

  appendCoverType(data, quoteDetail); // QuoteProcess_CustomizeCover

  appendCovers(data, quoteDetail); // QuoteProcess_Claims

  appendClaims(data, quoteDetail); // QuoteProcess_Declarations

  appendDeclarations(data, quoteDetail); // Property

  appendCoveragePropertyInfo(data, quoteDetail); // Extra fields

  appendRecruitmentSpecialInfo(data, quoteDetail);
  return data;
};

var convertAccelerantGitLocalQuoteDataToServerStructureData = function convertAccelerantGitLocalQuoteDataToServerStructureData(data, quoteDetail) {
  var insuranceBundle = quoteDetail.insuranceBundle,
      birthDate = quoteDetail.birthDate;
  appendBasicInfo(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // * QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_BusinessActivities

  appendBusinessActivity(data, quoteDetail);
  data.insuranceBundle = insuranceBundle;
  data.birthDate = birthDate;
  appendEmployees(data, quoteDetail);
  appendVehicles(data, quoteDetail); // QuoteProcess_CustomizeCover

  appendCovers(data, quoteDetail); // QuoteProcess_Declarations

  appendDeclarations(data, quoteDetail); // AppendCoverageConfiguration

  appendCoverageConfiguration(data, quoteDetail);
  return data;
};

var convertHiscoxUSLocalQuoteDataToServerStructureData = function convertHiscoxUSLocalQuoteDataToServerStructureData(data, quoteDetail) {
  appendBasicInfo(data, quoteDetail); // QuoteProcess_BusinessType

  appendBusinessType(data, quoteDetail); // QuoteProcess_CompanyAddress

  appendCompanyAndAddress(data, quoteDetail); // QuoteProcess_RetroactiveDate

  appendRetroactiveDate(data, quoteDetail);
  appendPolicyPeriodDate(data, quoteDetail); // QuoteProcess_BusinessActivities

  appendBusinessActivity(data, quoteDetail); // QuoteProcess_EstimatedTurnover

  appendEstimatedTurnover(data, quoteDetail);
  appendEmployees(data, quoteDetail); // QuoteProcess_CustomizeCover

  appendCovers(data, quoteDetail); // QuoteProcess_Declarations

  appendDeclarations(data, quoteDetail); // Extra fields

  appendHiscoxUSSpecialInfo(data, quoteDetail);
  return data;
};

export var convertLocalQuoteDetailDataToServerStructureData = function convertLocalQuoteDetailDataToServerStructureData(quoteDetail) {
  if (!quoteDetail) {
    return quoteDetail;
  }

  var insuranceInfo = getQuoteCurrentInsuranceInfo(quoteDetail);
  var submitData = {};

  if (insuranceInfo.isGreateAmerican) {
    submitData = convertGreatAmericanLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isChubb) {
    submitData = convertChubbLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isAccelerant) {
    submitData = convertAccelerantLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isRecruitment) {
    submitData = convertRecruitmentLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isGreateAmericanBussinessInsurance) {
    submitData = convertGreatAmericanBusinessInsuranceLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isGit) {
    submitData = convertAccelerantGitLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  } else if (insuranceInfo.isHiscoxUS) {
    submitData = convertHiscoxUSLocalQuoteDataToServerStructureData(submitData, quoteDetail);
  }

  return _objectSpread(_objectSpread({}, submitData), insuranceInfo);
};